import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
  Chip,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import RocketLaunchRoundedIcon from '@mui/icons-material/RocketLaunchRounded';
import { Link as ScrollLink } from 'react-scroll';
import './Navbar.css';

const Navbar = ({ sections }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileAnchorEl, setMobileAnchorEl] = useState(null);

  const handleMobileMenuClick = (event) => {
    setMobileAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMobileAnchorEl(null);
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        px: { xs: 2, sm: 4, md: 6 },
        py: 1,
        backgroundColor: 'rgba(2, 6, 23, 0.85)',
        backdropFilter: 'blur(18px)',
        borderBottom: '1px solid rgba(148, 163, 184, 0.18)',
      }}
    >
      <Toolbar disableGutters sx={{ minHeight: 64 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexGrow: 1 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '40%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'linear-gradient(135deg, rgba(96,165,250,0.3), rgba(244,114,182,0.3))',
              border: '1px solid rgba(148, 163, 184, 0.35)',
            }}
          >
            <RocketLaunchRoundedIcon color="primary" fontSize="small" />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: 0.4 }}>
              Guillermo Tafoya
            </Typography>
            <Chip
              label="Stuff Builder"
              color="primary"
              size="small"
              variant="outlined"
              sx={{
                mt: 0.5,
                color: 'primary.light',
                borderColor: 'rgba(96,165,250,0.45)',
                backgroundColor: 'rgba(37, 99, 235, 0.08)',
                fontWeight: 500,
              }}
            />
          </Box>
        </Box>

        {!isMobile && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {sections.map((section) => (
              <Button
                key={section.id}
                color="inherit"
                component={ScrollLink}
                to={section.id}
                smooth
                duration={600}
                spy
                offset={-120}
                className="navbar-item"
                activeClass="active-section"
                sx={{
                  px: 2.5,
                  py: 1,
                  borderRadius: '999px',
                  fontWeight: 500,
                }}
              >
                {section.label}
              </Button>
            ))}
          </Box>
        )}

        {isMobile && (
          <IconButton
            size="large"
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={handleMobileMenuClick}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Menu
          anchorEl={mobileAnchorEl}
          open={Boolean(mobileAnchorEl)}
          onClose={handleMenuClose}
          PaperProps={{
            sx: {
              mt: 1,
              borderRadius: 3,
              minWidth: 180,
              backgroundColor: 'rgba(15, 23, 42, 0.9)',
              border: '1px solid rgba(148, 163, 184, 0.18)',
              backdropFilter: 'blur(18px)',
            },
          }}
        >
          {sections.map((section) => (
            <MenuItem
              key={section.id}
              onClick={() => {
                handleMenuClose();
                const scrollToSection = document.getElementById(section.id);
                if (scrollToSection) {
                  scrollToSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
              sx={{ fontWeight: 500 }}
            >
              {section.label}
            </MenuItem>
          ))}
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
